import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  callButton: FelaCSS;
  link: FelaCSS;
}

const styles = (): IStyles => ({
  callButton: {
    height: 48,
    width: '100%',
  },
  link: {
    width: 48,
    borderRadius: 50,
    justifyContent: 'center',
    border: `1px solid ${colors.space08}`,
    backgroundColor: colors.white,
  },
});

export default styles;
